
import axiosServices from './request';

const MatrixCenter = axiosServices('matrix');
const AppletCenter = axiosServices('learnium');
const ExercisebookCenter = axiosServices('exercisebook');

export default {
  //学情分析-智能刷题
  queryIntelligentBrushQuestion: MatrixCenter('get', 'learnSituationAnalysis/queryIntelligentBrushQuestion'),
  // 获取用户试卷测验情况
  queryPaperTestCensusBy: MatrixCenter('get', 'learnSituationAnalysis/queryPaperTestCensusBy'),
  //获取用户古诗词背诵情况
  queryPoetryReciteReportBy: MatrixCenter('get', 'learnSituationAnalysis/queryPoetryReciteReportBy'),
  // 获取用户作文批改情况
  queryReportCorrectionBy: MatrixCenter('get', 'learnSituationAnalysis/queryReportCorrectionBy'),
  // 获取用户口算批改情况
  queryArithmeticRecordBy: MatrixCenter('get', 'learnSituationAnalysis/queryArithmeticRecordBy'),
  // 获取用户背单词情况
  queryMiniUserSheetReport: MatrixCenter('get', 'learnSituationAnalysis/queryMiniUserSheetReport'),
  // 获取日期列表
  getStudyHistoryDateList: MatrixCenter('get', 'report/weeklyStudyDuration/getStudyHistoryDateList'),
  // 获取本周浏览的书籍
  getWeeklyBookList: MatrixCenter('get', 'report/weeklyBook/list'),
  // 用户周学习总时长、图表list数据
  getWeeklyStudyDuration: MatrixCenter('get', 'report/weeklyStudyDuration/list'),
  // 获取当前用户排名
  getUserTop: MatrixCenter('get', 'report/weeklyStudyDuration/getUserTop'),
  // 获取TOP100排名
  getTop100: MatrixCenter('get', 'report/weeklyStudyDuration/getTop100'),
  // 点赞数
  getLikeCountByUserId: MatrixCenter('get', 'report/weeklyLike/getLikeCountByUserId'),
  // 用户点赞
  addLike: MatrixCenter('get', 'report/weeklyLike/addLike'),
  // 获取足迹
  getDayList: MatrixCenter('get', 'report/weeklyFoot/day/list'),
  // 获取用户信息
  getUserInfo: MatrixCenter('get', 'report/user/getUserInfo'),
  /** 创建伴学乐园小程序码 */
  createQrcode: AppletCenter('post', 'applet/createQrcode'),
  /** 获取伴学乐园用户信息 */
  getLearniumUserInfo: AppletCenter('get', 'user/getUserInfo'),
  /** 获取vip列表 */
  getVIPList: AppletCenter('get', 'VIPLevel/getVIPList'),
  /** 创建小程序码 */
  createXRQrcode: ExercisebookCenter('post', 'applet/createQrcode'),
  // 荣誉勋章-获取当前未领取奖励的勋章数
  getUserIsCanReceiveCount: MatrixCenter('get', 'medal/getUserIsCanReceiveCount')
};
